import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { optimizationApi, type OptimizationDashboard } from '../../api/optimization';

const NAV = [
  { to: '/optimization', label: 'Optimization Center' },
  { to: '/optimization/recommendations', label: 'Recommendations' },
  { to: '/optimization/cost', label: 'Cost Intelligence' },
  { to: '/optimization/capacity', label: 'Capacity Planning' },
  { to: '/optimization/performance', label: 'Performance Engineering' },
  { to: '/optimization/self-healing', label: 'Self-Healing Center' },
  { to: '/optimization/benchmarks', label: 'Benchmarks' },
  { to: '/optimization/health', label: 'Platform Health' },
  { to: '/optimization/timeline', label: 'Execution Timeline' },
];

export function OptimizationHubPage() {
  const [dash, setDash] = useState<OptimizationDashboard | null>(null);
  useEffect(() => { void optimizationApi.dashboard().then(setDash); }, []);
  const stats = dash ? [
    { label: 'Open Recommendations', value: dash.open_recommendations },
    { label: 'Total Savings', value: `$${dash.total_savings_usd.toFixed(0)}` },
    { label: 'Performance Score', value: dash.performance_score.toFixed(0) },
    { label: 'Capacity Alerts', value: dash.capacity_alerts },
    { label: 'Self-Healing Events', value: dash.self_healing_events },
    { label: 'Avg Confidence', value: `${(dash.average_confidence * 100).toFixed(0)}%` },
    { label: 'Autonomous Mode', value: dash.autonomous_mode },
    { label: 'Executed', value: dash.executed_optimizations },
  ] : [];
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Autonomous Platform Optimization</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Self-healing, cost intelligence, capacity management and continuous improvement.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">{NAV.map((l) => <Link key={l.to} to={l.to} className="text-violet-700 hover:underline dark:text-violet-400">{l.label}</Link>)}</nav>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">{stats.map((s) => (
        <div key={s.label} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900"><p className="text-sm text-slate-500">{s.label}</p><p className="mt-1 text-xl font-semibold">{String(s.value)}</p></div>
      ))}</div>
    </div>
  );
}
